// extracted by mini-css-extract-plugin
export default {"maindiv":"productItem_maindiv__DkZ+V","options":"productItem_options__wOKO+","cart":"productItem_cart__GJmCT"};